import { render, staticRenderFns } from "./ProductsVideos.vue?vue&type=template&id=50c79eee&scoped=true&"
import script from "./ProductsVideos.vue?vue&type=script&lang=js&"
export * from "./ProductsVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c79eee",
  null
  
)

export default component.exports